import type { AdaptationView, CanonicalPeriod, EmissionTier } from '../common'
import PropertyExtremeWind from './PropertyExtremeWind'

type PropertyWindGustProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
  view?: AdaptationView
}

export default function PropertyWindGust(props: PropertyWindGustProps) {
  return <PropertyExtremeWind {...props} hazardCode="wind_gust" />
}
